import React from 'react'
import { Route, Routes } from 'react-router-dom'

import FoundClaimPage from 'pages/Found/Claim'
import FoundConfirmationPage from 'pages/Found/Confirmation'
import FoundDetailsPage from 'pages/Found/Details'
import FoundLookupPage from 'pages/Found/Lookup'

export default () => (
  <Routes>
    <Route path='claim/:token' element={<FoundClaimPage />} />
    <Route path='confirmation/:token' element={<FoundConfirmationPage />} />
    <Route path=':number' element={<FoundDetailsPage />} />
    <Route index element={<FoundLookupPage />} />
  </Routes>
)
